import { render } from "./KontraktualSatker.vue?vue&type=template&id=ef7b9c40"
import script from "./KontraktualSatker.vue?vue&type=script&lang=js"
export * from "./KontraktualSatker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__